import React from 'react';
import { Button, Modal, Tooltip } from 'antd';
import { EmailTemplate } from '../types';
import TemplateMetricsModal from './TemplateMetricsModal';

type Props = {
  template: EmailTemplate,
};

export default function ViewTemplateMetricsButton(props: Props) {
  const [visible, setVisible] = React.useState(false);
  return (
    <>
      <Tooltip title="View performance metrics">
        <Button
          className={`${props.className || ''} cursor-pointer`}
          icon="line-chart"
          shape="round"
          style={{ padding: '0 8px' }}
          onClick={() => setVisible(true)}
        />
      </Tooltip>
      <Modal
        title={`Performance metrics for ${props.template.name}`}
        visible={visible}
        width={800}
        onCancel={() => setVisible(false)}
        onOk={() => setVisible(false)}
      >
        <TemplateMetricsModal templateId={props.template.id} />
      </Modal>
    </>
  );
}
